import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    popoverClass: {
      marginLeft: '48px',
      marginTop: '4px',
    },
    // Lines up with the module label: an 18px icon plus its 12px gap, less the
    // button's own padding
    customiseButton: {
      marginTop: 6,
      marginLeft: 22,
      '& .MuiButton-startIcon': {
        marginRight: 6,
      },
      '& .MuiButton-endIcon': {
        marginLeft: 4,
      },
    },
  })
);
